module.exports = __webpack_public_path__ + "static/media/blockchain.0ee1aa40.png";